import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ReportsRequestPage.SectionReportTypeRequest', {
    sectionTitleIntegrations: '{integrationName} Workflows',
    sectionTitleOtherIntegrations: 'Other workflows',
    sectionTitleStandalone: 'Standalone workflows',
    emptyPlaceholder: 'This report will show data for all request types.',
});
